import {lazy} from "react"

const ModeratorDashboard = lazy(() => import("components/moderator/ModeratorDashboard"))

const DistributorAdd = lazy(() => import("components/distributors/add/DistributorAdd"))
const DistributorEdit = lazy(() => import("components/distributors/edit/DistributorEdit"))

const ProductAdd = lazy(() => import("components/products/add/ProductAdd"))
const ProductEdit = lazy(() => import("components/products/edit/ProductEdit"))
const ManageDistributorProducts = lazy(() => import("components/distributors/manageProducts/ManageDistributorProducts"))

const ArticleAdd = lazy(() => import("../components/resources/edit/ArticleAdd"))

const ProductImport = lazy(() => import("../components/products/import/ProductImport"))

const UpdateIsos = lazy(() => import("../components/moderator/update-isos/UpdateIsos"))
const RemoveDistributors = lazy(() => import("../components/moderator/remove-distributors/RemoveDistributors"))
const ReindexProducts = lazy(() => import("../components/moderator/ReindexProducts"))
const RemoveOrphanedProductIsos = lazy(() => import("../components/moderator/RemoveOrphanedProductIsos"))


export const routes = {
    "/moderator": {
        label: "Moderator Dashboard",
        component: ModeratorDashboard,
        exact: true
    },
    "/moderator/products-without-images": {
        label: "Products Without Images",
        component: ModeratorDashboard,
        exact: true
    },
    "/moderator/products-without-isos": {
        label: "Products Without ISOs",
        component: ModeratorDashboard,
        exact: true
    },
    "/moderator/products-without-distributors": {
        label: "Products Without Distributors",
        component: ModeratorDashboard,
        exact: true
    },
    "/moderator/distributors": {
        label: "Distributors",
        component: ModeratorDashboard,
        exact: true
    },
    "/moderator/update-isos": {
        label: "Update ISOs",
        component: UpdateIsos,
        exact: true
    },
    "/moderator/remove-distributors": {
        label: "Remove Distributors",
        component: RemoveDistributors,
        exact: true
    },
    "/moderator/reindex-products": {
        label: "Reindex Products",
        component: ReindexProducts,
        exact: true
    },
    "/moderator/remove-orphaned-product-isos": {
        label: "Remove Orphaned Product Isos",
        component: RemoveOrphanedProductIsos,
        exact: true
    },
    "/distributors/add": {
        label: "Add Distributor",
        component: DistributorAdd
    },
    "/distributors/edit/:id": {
        label: "Edit Distributor",
        component: DistributorEdit
    },
    "/products/add/:distributorId?": {
        label: "Add Product",
        component: ProductAdd
    },
    "/products/edit/:id/:tabIndex?": {
        label: "Edit Product",
        component: ProductEdit
    },
    "/products/import": {
        label: "Import Products",
        component: ProductImport
    },
    "/distributors/manage-products/:id": {
        label: "Manage Distributor Products",
        component: ManageDistributorProducts
    },
    "/resources/add": {
        label: "Add Informational Resource",
        component: ArticleAdd,
        exact: true
    }
}
